import { render, staticRenderFns } from "./SummaryTile.vue?vue&type=template&id=dafdb4b4&scoped=true&"
import script from "./SummaryTile.vue?vue&type=script&lang=js&"
export * from "./SummaryTile.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTile.vue?vue&type=style&index=0&id=dafdb4b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafdb4b4",
  null
  
)

export default component.exports